import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import MetisMenu from 'react-metismenu';
import {HomeNav, HomeNav2} from './NavItems';
import requestApi from "../../services/requestApi.service";
import {
    getMappedFormName, 
    getSessionValue, 
    getURLParameters, 
    parseJSON, 
    setSessionValue, 
    validateLogin,
    handleErrorResponse, 
    getLogoutURL, 
    getAppType,
    clearLegacyCookie,
} from "../../Common/Appcommon";
import {setEnableMobileMenu} from "../../reducers/ThemeOptions";

class Nav extends Component {

    constructor(props) {
        super(props);
        let menuList = getSessionValue('menus');
        let menus = (menuList !== '' && menuList !== undefined && menuList !== 'undefined' && menuList !== null) ? parseJSON(menuList) : [];
        this.state = {
            menus : menus,
            activeLinkTo: '/#',
            userProfileName : '',
        };
    }

    componentDidMount = async() => {
        let isMenuClicked = getSessionValue("menuClicked");
        if (window.performance) {
            let isValidSession = await this.isValidSession();
            if(isValidSession === true && isValidSession !==undefined && isValidSession !==""){
                if (performance.navigation.type == 1 && (!isMenuClicked || isMenuClicked === "false")) {
                    await validateLogin("", false);
                } else {
                    setSessionValue("menuClicked", false);
                    //alert( "This page is not reloaded");
                }
            }else {
                clearLegacyCookie();
                window.location = getLogoutURL();
            }
        }
        let userProfileName = getSessionValue('profileName');

        if(userProfileName !== undefined && userProfileName !== null){
            userProfileName = userProfileName.toLowerCase();
            if (userProfileName.includes('admin')) {
                userProfileName = 'admin';
            }else if(userProfileName.includes('manager')){
                userProfileName = 'manager';
            }else if(userProfileName.includes('employee')){
                userProfileName = 'employee';
            };
        }else{
            userProfileName = '';
        }

        // if(menus.length === 0){
        //     menuList = getSessionValue('menus');
        //     menus = (menuList !== '' && menuList !== undefined && menuList !== 'undefined' && menuList !== null) ? parseJSON(menuList) : [];
        // }

        this.setState({
            activeLinkTo: window.location.hash,
            userProfileName : userProfileName,
        });
    }

    componentWillReceiveProps() {
        
    }
    

    getMenuDetails = async () => {
        let appType = getAppType();
        let params = {
            "ENTITY" : "WHATSAPPPROCESS",
            "OPERATION" : "GETMENUS",
            "APPTYPE" : appType,
        }
        let response = await requestApi.processServerRequest(params, "WebV2","get", false);
        if(response.issuccess){
            let menus = response.data;
            setSessionValue('menus', JSON.stringify(menus));
            this.setState({
                menus
            })
        }
    }

    isValidSession = async () => {
        let res = "";
        let params = {
            "ENTITY" : "session_check",
        }

        let response = await requestApi.processServerRequest(params);
       // console.log(response)
        if(response.issuccess){
            res = response.data['isValidSession'];
        }else{
            handleErrorResponse(response.errormsg);
        }
        return res;
    }


    toggleMobileSidebar = (e) => {
        setTimeout(()=>{
            let selectMenu = e.view.window.location.hash;
            let params = getURLParameters(selectMenu);
            let formname = "";
            if(params['form'] !== undefined){
                let formLabel = params['form'];
                formLabel = formLabel.replaceAll("_", " ");
                formname = getMappedFormName(formLabel);
            }
            let iframe = document.getElementById('cloned_iframe');
            if(iframe != null){
                let msgData = "frefresh|"+formname;
                iframe.contentWindow.postMessage(msgData, "*");
            }
        },200);
        
        let { enableMobileMenu, setEnableMobileMenu } = this.props;
        let currentmenu = getSessionValue("currentmenu");
        let previousmenu = getSessionValue("previousmenu");
        setEnableMobileMenu(!enableMobileMenu);
        if(previousmenu === currentmenu){
            setTimeout(()=>{
                setSessionValue("menuClicked",true);
                //window.location.reload();
            },200);
        }
    };

    render() {
        let {menus} = this.state;
        if(menus.length === 0){
            return <Fragment></Fragment>
        }
        let appType = getAppType();
        let homeMenus = HomeNav2;
        let marketingMenus = menus;
        let settingsMenu = [];
        let callsMenu = [];
        let fieldSalesMenu = [];
        let rcsMenu = [];
        if(appType === "2"){
            homeMenus = menus[0];
            settingsMenu = menus[2];
            callsMenu = menus[4];
            fieldSalesMenu = menus[7];
            if(menus.length > 8){
                rcsMenu = menus[8];
            }
            /*let newMenus = [];
            menus.map((menu, index) => {
                if(index !== menus.length - 1){
                    newMenus.push(menu);
                }
            })*/
            marketingMenus = menus[1];
        } else if (appType === "1"){
            homeMenus = menus[1];
            marketingMenus = [];
        }

        return (
            <Fragment>
                <h5 className={`app-sidebar__heading ${appType === "2" ? '' : 'top-menuspace'}`}>
                    {appType === "2" ? "CRM" : ""}
                </h5>
                <MetisMenu
                    content={homeMenus}
                    activeLinkTo={this.state.activeLinkTo}
                    onSelected={this.toggleMobileSidebar}
                    className="vertical-nav-menu"
                    iconNamePrefix=""
                    classNameStateIcon="pe-7s-angle-down"
                />
                {
                    appType === "2" &&
                    callsMenu.length > 0 &&
                    <>
                        <h5 className="app-sidebar__heading">CALLS</h5>
                        <MetisMenu
                            content={callsMenu}
                            onSelected={this.toggleMobileSidebar}
                            activeLinkTo={this.state.activeLinkTo}
                            className="vertical-nav-menu"
                            iconNamePrefix=""
                            classNameStateIcon="pe-7s-angle-down"
                        />
                    </>
                }
                {
                    appType === "2" &&
                    fieldSalesMenu.length > 0 &&
                    <>
                        <h5 className="app-sidebar__heading">FIELD SALES</h5>
                        <MetisMenu
                            content={fieldSalesMenu}
                            onSelected={this.toggleMobileSidebar}
                            activeLinkTo={this.state.activeLinkTo}
                            className="vertical-nav-menu"
                            iconNamePrefix=""
                            classNameStateIcon="pe-7s-angle-down"
                        />
                    </>
                }
                {
                    appType === "2" &&
                    marketingMenus.length > 0 &&
                    <>
                        <h5 className="app-sidebar__heading">WHATSAPP</h5>
                        <MetisMenu
                            content={marketingMenus}
                            onSelected={this.toggleMobileSidebar}
                            activeLinkTo={this.state.activeLinkTo}
                            className="vertical-nav-menu"
                            iconNamePrefix=""
                            classNameStateIcon="pe-7s-angle-down"
                        />
                    </>
                }
                {
                    appType === "2" &&
                    rcsMenu.length > 0 &&
                    <>
                        <h5 className="app-sidebar__heading">RCS</h5>
                        <MetisMenu
                            content={rcsMenu}
                            onSelected={this.toggleMobileSidebar}
                            activeLinkTo={this.state.activeLinkTo}
                            className="vertical-nav-menu"
                            iconNamePrefix=""
                            classNameStateIcon="pe-7s-angle-down"
                        />
                    </>
                }
                {
                    settingsMenu.length > 0 &&
                    <>
                        {
                            appType === "2" &&
                            settingsMenu[0] !== '' &&
                            this.state.userProfileName !== 'employee' &&
                            <>
                                <h5 className="app-sidebar__heading">ACCOUNT</h5>
                                <MetisMenu
                                    content={settingsMenu}
                                    onSelected={this.toggleMobileSidebar}
                                    activeLinkTo={this.state.activeLinkTo}
                                    className="vertical-nav-menu"
                                    iconNamePrefix=""
                                    classNameStateIcon="pe-7s-angle-down"
                                />
                            </>
                        }
                    </>
                }
            </Fragment>
        );
    }

    isPathActive(path) {
        return this.props.location.pathname.startsWith(path);
    }
}
const mapStateToProps = (state) => ({
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
    setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
